import { MDBListGroup, MDBListGroupItem } from "mdb-react-ui-kit";

export const renderListItems = (items, renderItem) => {
  return (
    <MDBListGroup>
      {items?.map((item, index) => (
        <MDBListGroupItem key={index} className="d-flex align-items-start">
          {renderItem(item)}
        </MDBListGroupItem>
      ))}
    </MDBListGroup>
  );
};

export const renderDoiItem = (item) => (
  <>
    <div>
      <strong>DOI:</strong> {item?.DOI}
      <br />
      <strong>Reference:</strong> {item?.title}
    </div>
  </>
);

export const renderInvalidDoiItem = (item) => (
  <>
    <div>
      <strong>Invalid DOI:</strong> {item?.doi ?? item?.DOI}
      <br />
      <strong>Reference:</strong> {item?.title}
    </div>
  </>
);

export const renderDoiReferenceList = (items, showDoi = true) => {
  if (!items || items.length === 0) return null;

  return (
    <ol className="mb-0">
      {items.map((item, index) => {
        const doi = item?.doi ?? item?.DOI;
        const authors = item?.authors ?? '';

        return (
          <li
            key={item?.referenceNumber ?? index}
            value={item?.referenceNumber}
            className={index === items.length - 1 ? "" : "mb-2"}
          >
            <div>
              {authors ? <>{authors.endsWith('.') ? authors : `${authors}.`} </> : null}
              {item?.title}
              {item?.journal && (
                <>
                  . <em>{item.journal}</em>
                </>
              )}
              {showDoi && doi && <>. <strong>DOI: {doi}</strong></>}
            </div>
            {item?.contextFlag === "uncited" && (
              <span className="badge bg-warning text-dark mt-1">Unused</span>
            )}
            {item?.contextFlag === "outOfContext" && (
              <div className="mt-1">
                <span className="badge bg-danger">Out of context</span>
                {item?.contextMismatch && (
                  <div className="text-muted small mt-1">
                    {item.contextMismatch}
                  </div>
                )}
              </div>
            )}
          </li>
        );
      })}
    </ol>
  );
};

export const renderRetractionWatchItem = (item) => (
  <>
    <div>
      <strong>DOI:</strong> {item?.DOI}
      {item?.byNature && item?.totalMatches && (
        <span>
          &nbsp;|&nbsp;{item.totalMatches}x total (
          {Object.entries(item.byNature)
            .sort()
            .map(([nature, count]) => `${count}x ${nature}`)
            .join(', ')}
          )
        </span>
      )}
      <br />
      <strong>Reference:</strong> {item?.title}
    </div>
  </>
);